module.exports = __webpack_public_path__ + "img/coupon-sharer-bg.9a7f703.png";